import { render, staticRenderFns } from "./moreMsg.vue?vue&type=template&id=0fa06480&"
import script from "./moreMsg.vue?vue&type=script&lang=js&"
export * from "./moreMsg.vue?vue&type=script&lang=js&"
import style0 from "./moreMsg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports